export default __webpack_public_path__ + "static/media/checkmark.e88c2ff8.PNG";